/* TENDD to Change scan.
   Ported from the standalone app that ran on scan.tendd.nl, which was a
   single self-contained HTML file deployed to Netlify with no linked Git
   repository. The statements, the four routes and every line of result copy
   below are lifted verbatim from that file rather than retyped, so the
   wording cannot drift from what the client wrote.

   One thing behaves differently here: the result is no longer shown the
   moment the last statement is answered. It is computed, held, and released
   once an address has been left, so the report can also be mailed -- the
   point of moving the scan onto the shop. Nothing is sent anywhere until
   that step, and the newsletter is a separate, optional tick. */

const SECTIONS = [
  {
    key:'A', color:'var(--a)', title:'Uitvoering & volhouden',
    items:[
      'Ik neem me vaak iets voor, maar op het moment zelf doe ik het niet.',
      'Ik stel dingen uit die belangrijk voor me zijn.',
      'Ik begin enthousiast, maar na een paar dagen of weken verdwijnt het weer.',
      'Ik wacht op motivatie, rust of het juiste moment.',
      'Mijn doelen blijven vaak te groot of te vaag om er vandaag mee te starten.',
      'Zodra het ergens tegenzit of het druk wordt, stop ik meestal helemaal in plaats van kleiner door te gaan.'
    ]
  },
  {
    key:'B', color:'var(--b)', title:'Kies wat klopt',
    items:[
      'Ik zeg vaker ja dan ik eigenlijk wil.',
      'Ik vind het lastig om nee te zeggen zonder schuldgevoel of veel uitleg.',
      'Ik pas me snel aan als ik voel dat iemand iets van mij verwacht.',
      'Mijn agenda, energie of aandacht wordt vaak gevuld door wat anderen nodig hebben.',
      'Ik weet vaak wel wat beter voor mij zou zijn, maar ik kies er niet altijd naar.',
      'Ik merk vaak pas achteraf — via vermoeidheid, irritatie of een vervelend gevoel — dat ik over mijn eigen grens ben gegaan.'
    ]
  },
  {
    key:'C', color:'var(--c)', title:'Richting, ruimte & koers',
    items:[
      'Ik heb vaak het gevoel dat mijn dagen gevuld worden door wat moet, niet door wat ik bewust kies.',
      'Ik wil meer uit mijn leven halen dan hoe ik het nu leef.',
      'Ik verlang naar meer richting, ruimte en eigenaarschap.',
      'Ik heb veel ideeën of wensen, maar mis focus in wat nu aandacht verdient.',
      'Ik betrap mezelf erop dat ik keuzes maak omdat ze passen bij wat anderen van mij verwachten, niet omdat ik ze echt zelf wil.',
      'Ik houd liever meerdere opties tegelijk open dan dat ik er één kies, uit angst dat ik een verkeerde keuze maak.'
    ]
  },
  {
    key:'D', color:'var(--d)', title:'Loslaten wat niet meer past',
    items:[
      'Ik twijfel steeds opnieuw aan een relatie, vriendschap, familieband of samenwerking die veel invloed heeft op mijn rust.',
      'Na contact met deze persoon voel ik me vaker leeg, gespannen, klein of verward.',
      'Ik blijf hangen door hoop, schuld, geschiedenis, angst of loyaliteit.',
      'Ik merk dat ik mijn woorden, grenzen of behoeften aanpas om gedoe te voorkomen.',
      'Ik vind het moeilijk onderscheid te maken tussen herstellen, afstand\u00a0nemen en beëindigen.',
      'Ik zoek regelmatig redenen om het gedrag van deze persoon te verklaren, alsof het misschien wel logisch is dat diegene zich zo gedraagt.'
    ]
  }
];

const RESULTS = {
  A:{
    title:'Het onderdeel "Doen dat blijft" vraagt het meest om jouw aandacht momenteel.',
    route:'Doen dat blijft',
    herkenning:'Je stelt uit, maakt doelen te groot, wacht op motivatie of begint wel maar valt na een paar dagen terug in het oude patroon. Niet omdat je het niet wil, maar omdat de eerste stap steeds net te groot of te vaag blijft om hem nu meteen te zetten.',
    helpt:'Je hebt geen extra discipline nodig, maar een kleinere, tastbaardere versie van wat je al wil. Werk met een vaste trigger, een piepklein eerste handelingetje, één duidelijke kernactie en een simpele regel voor de dagen dat het tegenzit.',
    stap:'Kies één ding dat je al langer wil doen en knip het zo klein dat je het binnen twee minuten kunt uitvoeren. Niet de hele gewoonte, alleen de allereerste beweging — de rest volgt vanzelf zodra die drempel weg is.',
    training:'Doen dat blijft',
    voorbeeldBeweging:'mijn hardloopschoenen alvast bij de deur zetten, zodat de eerste stap al gezet is',
    voorbeeldWanneer:'maandag t/m vrijdag, direct na het opstaan',
    voorbeeldMinimum:'twee minuten, zonder uitzondering',
    voorbeeldBewijs:'ik hoef er niet meer bewust over na te denken, het gaat vanzelf',
    trainingUrl:'https://www.tendd.nl/products/doendatblijft?variant=57567875400012'
  },
  B:{
    title:'Het onderdeel "Kies wat klopt" vraagt het meest om jouw aandacht momenteel.',
    route:'Kies wat klopt',
    herkenning:'Je zegt vaker ja dan je bedoelt, past je aan zodra je voelt dat iemand iets van je verwacht, en merkt vaak pas achteraf — via vermoeidheid of irritatie — dat je over je eigen grens bent gegaan. Niet omdat je geen mening hebt, maar omdat de pauze om die mening te voelen er vaak niet is.',
    helpt:'Je hebt geen hardheid nodig, maar helderheid: weten wat voor jou telt, wat energie geeft en wat je energie kost, vóórdat je antwoord geeft. Een korte pauze tussen vraag en antwoord geeft je precies de ruimte die je nu vaak mist.',
    stap:'Gebruik bij het eerstvolgende verzoek eerst: "ik denk er even over na en kom erop terug." Die ene zin koopt je de tijd om te voelen wat je eigenlijk wil, in plaats van meteen te reageren vanuit gewoonte.',
    training:'Kies wat klopt',
    voorbeeldBeweging:'bij het eerstvolgende verzoek zeggen: "ik denk er even over na en kom erop terug"',
    voorbeeldWanneer:'zodra ik merk dat ik "ja" wil zeggen terwijl ik het niet meen',
    voorbeeldMinimum:'alleen die ene zin, zonder verdere uitleg of verontschuldiging',
    voorbeeldBewijs:'ik hoef mijn "nee" niet meer te verdedigen of goed te praten',
    trainingUrl:'https://www.tendd.nl/products/reset-richting-en-regie?variant=57571037872460'
  },
  C:{
    title:'Het onderdeel "Leef je Koers" vraagt het meest om jouw aandacht momenteel.',
    route:'Leef je Koers',
    herkenning:'Je leven loopt misschien prima, maar je dagen worden gevuld door wat moet in plaats van wat je zelf kiest. Je verlangt naar meer richting en eigenaarschap, maar mist de focus om te bepalen wat daarvoor nu aandacht verdient — en soms merk je dat keuzes meer bepaald worden door wat anderen van je verwachten dan door wat jij zelf wil.',
    helpt:'Bepaal eerst helder wat voor jou telt en waar je naartoe wil, en vertaal die koers pas dán naar concreet gedrag: een ritme, subdoelen en een plan voor de komende maanden. Zonder die richting blijft elke actie los zand.',
    stap:'Blokkeer deze week één vast moment van 30 minuten in je agenda en vul het meteen met een naam — niet "aan mijn toekomst werken", maar het concrete ding zelf: bijvoorbeeld "cv bijwerken", "intakegesprek opleiding bellen" of "eerste hoofdstuk van mijn plan schrijven".',
    training:'Leef je Koers',
    voorbeeldBeweging:'een blok van 30 minuten in mijn agenda zetten, met een concrete naam erbij',
    voorbeeldWanneer:'één vast moment deze week, bijvoorbeeld zondagavond of vrijdagmiddag',
    voorbeeldMinimum:'al is het maar 10 minuten in plaats van 30',
    voorbeeldBewijs:'ik kan aanwijzen wat ik deze week heb gedaan dat echt bij mijn koers past',
    trainingUrl:'https://www.tendd.nl/products/doelen-bepalen-doelen-behalen?variant=57571110224204'
  },
  D:{
    title:'Het onderdeel "Loslaten wat niet meer past" vraagt het meest om jouw aandacht momenteel.',
    route:'Loslaten wat niet meer past',
    herkenning:'Een relatie, vriendschap, familieband, samenwerking of rol kost je structureel rust, energie of zelfrespect. Je twijfelt er steeds opnieuw aan, voelt je na contact vaak leeg of gespannen, en blijft hangen door hoop, schuld, geschiedenis of loyaliteit — en misschien betrap je jezelf erop dat je het gedrag van de ander goedpraat, alsof het logisch is dat diegene zich zo gedraagt.',
    helpt:'Kijk niet naar het losse incident, maar naar het patroon over tijd: je energie, je lichaamssignalen, wederkerigheid, grenzen en herhaald gedrag. Dat patroon vertelt je meer dan elk los moment ooit kan.',
    stap:'Schrijf drie momenten op waarop je dacht: "dit klopt niet meer." Markeer daarna wat ze gemeen hebben — dat patroon, niet het incident zelf, is waar je iets mee kunt doen.',
    training:'Relaties verbreken',
    voorbeeldBeweging:'drie momenten opschrijven waarop ik dacht: "dit klopt niet meer"',
    voorbeeldWanneer:'vandaag nog, voordat er weer contact is',
    voorbeeldMinimum:'al is het maar één moment, in plaats van drie',
    voorbeeldBewijs:'ik zie het patroon helderder dan alleen de losse incidenten',
    trainingUrl:'https://www.tendd.nl/products/relaties-verbreken?variant=57954145567052'
  }
};


const TOTAL_ITEMS = SECTIONS.reduce((n, s) => n + s.items.length, 0);
const STORAGE_KEY = 'tendd_to_change_scan_v1';
const NAMES = { A: 'Doen dat blijft', B: 'Kies wat klopt', C: 'Leef je Koers', D: 'Loslaten wat niet meer past' };

/* The newsletter is a real subscription, not a note on a profile:
   identify() alone does NOT subscribe anyone -- it creates or updates a
   profile and nothing more -- so the list is joined through Klaviyo's own
   client subscription endpoint, which is also what records the consent and
   its timestamp. It runs only when the visitor ticked the box.

   The result itself does not need a list. It rides on the event below, and
   the flow that mails it is triggered by that event.

   The list id is the newsletter list in Klaviyo (Lists & Segments -> the
   list -> the id in its URL). If it is ever blanked the subscription call
   is skipped silently, so it must not be left empty. */
const KLAVIYO_COMPANY_ID = 'SNvLtb';
const KLAVIYO_LIST_ID = 'WBPyqa';

let idCounter = 1;
const answers = {};
let pendingResult = null; // computed, waiting behind the e-mail step
/* renderResult runs twice on purpose -- once when /contact answers and once
   on the 2.5s timeout, so nobody is left watching a spinner. Rewriting the
   result twice is harmless; counting the conversion twice is not. */
let resultTracked = false;

function scaleLabel(v) {
  return { 1: 'Bijna niet', 2: 'Soms', 3: 'Regelmatig', 4: 'Vaak', 5: 'Heel sterk' }[v];
}

function buildScan() {
  const container = document.getElementById('sections');
  container.innerHTML = '';
  idCounter = 1;

  SECTIONS.forEach((section) => {
    const head = document.createElement('div');
    head.className = 'scan-section-head';
    head.innerHTML =
      '<div class="scan-tag scan-tag--' + section.key + '">' +
      '<span class="scan-sw"></span>Onderdeel ' + section.key + '</div>' +
      '<h2>' + section.title + '</h2>';
    container.appendChild(head);

    section.items.forEach((text) => {
      const id = idCounter++;
      const stmt = document.createElement('div');
      stmt.className = 'scan-stmt';
      stmt.innerHTML =
        '<div class="scan-num">Nr. ' + id + '</div>' +
        '<div class="scan-text">' + text + '</div>' +
        '<div class="scan-scale" role="radiogroup" aria-label="Score voor uitspraak ' + id + '">' +
        [1, 2, 3, 4, 5].map(function (v) {
          return '<label><input type="radio" name="q' + id + '" value="' + v + '" ' +
            'data-key="' + section.key + '" data-id="' + id + '">' +
            '<span class="scan-pip"><span class="scan-n">' + v + '</span>' +
            '<span class="scan-lbl">' + scaleLabel(v) + '</span></span></label>';
        }).join('') +
        '</div>';
      container.appendChild(stmt);
    });
  });

  // One listener on the container instead of an inline onchange per input:
  // the markup is built as a string, and inline handlers there would have to
  // be globals on window.
  container.addEventListener('change', function (e) {
    const input = e.target;
    if (!input.matches('input[type=radio]')) return;
    answers[input.dataset.id] = { key: input.dataset.key, value: Number(input.value) };
    saveProgress();
    updateProgress();
  });
}

function saveProgress() {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(answers)); } catch (e) { /* opslag niet beschikbaar */ }
}

function loadProgress() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const saved = JSON.parse(raw);
    const keys = Object.keys(saved);
    if (keys.length === 0) return false;
    keys.forEach(function (id) {
      answers[id] = saved[id];
      const radio = document.querySelector('input[name="q' + id + '"][value="' + saved[id].value + '"]');
      if (radio) radio.checked = true;
    });
    return true;
  } catch (e) { return false; }
}

function clearProgress() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
}

function updateProgress() {
  const answered = Object.keys(answers).length;
  document.getElementById('progress-fill').style.width = (answered / TOTAL_ITEMS * 100) + '%';
  document.getElementById('progress-text').textContent = answered + ' / ' + TOTAL_ITEMS + ' ingevuld';

  const btn = document.getElementById('calc-btn');
  const msg = document.getElementById('bottom-msg');
  if (answered === TOTAL_ITEMS) {
    btn.disabled = false;
    msg.textContent = 'Alle uitspraken beantwoord — je kunt je resultaat bekijken.';
  } else {
    btn.disabled = true;
    msg.textContent = 'Beantwoord alle ' + TOTAL_ITEMS + ' uitspraken om je resultaat te zien.';
  }
}

/* Meta pixel. The scan is one page: the screens swap in place and the URL
   never changes, so a custom conversion built on a URL rule can never fire
   for the result. It gets its own event instead. This does nothing at all
   until a pixel is actually on the site, and it never fires without the
   visitor's marketing consent -- measuring is not allowed to override that,
   and it is not allowed to break the scan either. */
function metaEvent(name, data) {
  try {
    if (typeof window.fbq !== 'function') return;
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.marketingAllowed === 'function' && !privacy.marketingAllowed()) return;
    window.fbq('trackCustom', name, data || {});
  } catch (e) { /* a blocked or missing pixel must not stop the scan */ }
}

function goTo(name) {
  document.querySelectorAll('.scan-screen').forEach(function (s) { s.classList.remove('is-active'); });
  document.getElementById('screen-' + name).classList.add('is-active');
  window.scrollTo({ top: 0, behavior: 'instant' });
  if (name === 'scan') { metaEvent('ScanGestart'); }
}

/* Scoring, unchanged from the original: six statements per route, the totals
   summed per route, highest wins. A gap of under three points between the
   top two is called out rather than silently resolved. */
function calculate() {
  const totals = { A: 0, B: 0, C: 0, D: 0 };
  Object.values(answers).forEach(function (a) { totals[a.key] += a.value; });

  const order = ['A', 'B', 'C', 'D'];
  const winner = order.reduce(function (best, k) { return totals[k] > totals[best] ? k : best; }, 'A');
  const sorted = order.slice().sort(function (x, y) { return totals[y] - totals[x]; });
  const gapClose = (totals[sorted[0]] - totals[sorted[1]]) < 3;

  pendingResult = { totals: totals, winner: winner, sorted: sorted, gapClose: gapClose };
  goTo('email');
}

function renderResult() {
  const r = pendingResult;
  if (!r) return;
  const totals = r.totals, winner = r.winner, sorted = r.sorted;
  const order = ['A', 'B', 'C', 'D'];

  document.getElementById('meters').innerHTML = order.map(function (k) {
    return '<div class="scan-meter' + (k === winner ? ' is-win' : '') + '">' +
      '<div class="scan-meter__name">' + k + ' · ' + NAMES[k] + '</div>' +
      '<div class="scan-meter__track"><i class="scan-meter__fill scan-meter__fill--' + k + '" data-w="' + (totals[k] / 30 * 100) + '"></i></div>' +
      '<div class="scan-meter__val">' + totals[k] + ' / 30</div>' +
      '</div>';
  }).join('');

  document.getElementById('tiebreak-note').style.display = r.gapClose ? 'block' : 'none';
  if (r.gapClose) {
    document.getElementById('tiebreak-scores').textContent =
      ' (' + sorted[0] + ': ' + totals[sorted[0]] + ' · ' + sorted[1] + ': ' + totals[sorted[1]] + ')';
  }

  document.getElementById('safety-note').style.display =
    (winner === 'D' || (r.gapClose && sorted.slice(0, 2).indexOf('D') !== -1)) ? 'block' : 'none';

  const res = RESULTS[winner];
  document.getElementById('verdict-eyebrow').textContent = 'Uitslag ' + winner;
  document.getElementById('verdict-title').textContent = res.title;
  document.getElementById('verdict-herkenning').textContent = res.herkenning;
  document.getElementById('verdict-helpt').textContent = res.helpt;
  document.getElementById('verdict-stap').textContent = res.stap;
  document.getElementById('verdict-training').textContent = res.training;

  document.getElementById('plan-hoogste').value = winner + ' — ' + NAMES[winner] + ' (' + totals[winner] + '/30)';
  document.getElementById('plan-route').value = res.route;
  document.getElementById('example-beweging').textContent = res.voorbeeldBeweging;
  document.getElementById('example-wanneer').textContent = res.voorbeeldWanneer;
  document.getElementById('example-minimum').textContent = res.voorbeeldMinimum;
  document.getElementById('example-bewijs').textContent = res.voorbeeldBewijs;

  const link = document.getElementById('training-link');
  const sep = res.trainingUrl.indexOf('?') !== -1 ? '&' : '?';
  link.href = res.trainingUrl + sep + 'utm_source=to_change_scan&utm_medium=quiz&route=' + winner;
  link.textContent = 'Bekijk de training "' + res.training + '"';

  clearProgress();
  if (!resultTracked) {
    resultTracked = true;
    metaEvent('ScanVoltooid', { route: winner, route_naam: NAMES[winner] || '' });
  }
  goTo('result');
  requestAnimationFrame(function () {
    document.querySelectorAll('.scan-meter__fill').forEach(function (el) {
      el.style.width = el.getAttribute('data-w') + '%';
    });
  });
}

/* The e-mail step. Two destinations, on purpose:

   - Klaviyo, so the address joins the list she already sends from and the
     event can trigger a flow that mails the report. The onsite script is
     loaded shop-wide by the Klaviyo app, so there is no key to keep here.
   - Shopify's own contact form, posted in the background, so a copy reaches
     her inbox even if Klaviyo is unavailable or blocked by an ad blocker.

   Whichever fails, the visitor still gets their result: neither call is
   allowed to hold the screen hostage. */
function submitEmail(e) {
  e.preventDefault();

  const emailField = document.getElementById('scan-email');
  const email = emailField.value.trim();
  const err = document.getElementById('scan-email-error');
  if (!email || email.indexOf('@') === -1) {
    err.style.display = 'block';
    emailField.focus();
    return false;
  }
  err.style.display = 'none';

  const btn = document.getElementById('scan-email-btn');
  btn.disabled = true;
  btn.textContent = 'Een moment…';

  const r = pendingResult || { totals: {}, winner: '', gapClose: false };
  const newsBox = document.getElementById('scan-news');
  const wantsNews = !!(newsBox && newsBox.checked);

  /* Keys without spaces on purpose. These are what the flow's e-mail reads
     back -- {{ event.scan_route_naam }} and so on -- and a property name
     with spaces in it cannot be written that way in a template. */
  const props = {
    scan_route: r.winner,
    scan_route_naam: NAMES[r.winner] || '',
    scan_score_a: r.totals.A,
    scan_score_b: r.totals.B,
    scan_score_c: r.totals.C,
    scan_score_d: r.totals.D,
    scan_scores_dicht_bij_elkaar: !!r.gapClose,
    nieuwsbrief: wantsNews
  };

  try {
    if (window.klaviyo) {
      const kl = window.klaviyo;
      const identify = Object.assign({ $email: email }, props);
      if (typeof kl.identify === 'function') { kl.identify(identify); } else { kl.push(['identify', identify]); }
      if (typeof kl.track === 'function') { kl.track('TENDD to Change Scan voltooid', props); }
      else { kl.push(['track', 'TENDD to Change Scan voltooid', props]); }
    }
  } catch (e2) { /* Klaviyo geblokkeerd of niet geladen — het resultaat gaat gewoon door */ }

  if (wantsNews && KLAVIYO_LIST_ID) {
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: props,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        })
      }).catch(function () { /* zie hieronder: de uitslag wacht hier niet op */ });
    } catch (e3) { /* idem */ }
  }

  const lines = [
    'Route: ' + r.winner + ' — ' + (NAMES[r.winner] || ''),
    'Scores: A ' + r.totals.A + ' · B ' + r.totals.B + ' · C ' + r.totals.C + ' · D ' + r.totals.D,
    'Scores dicht bij elkaar: ' + (r.gapClose ? 'ja' : 'nee'),
    'Wil de nieuwsbrief: ' + (wantsNews ? 'ja' : 'nee')
  ].join('\n');

  const body = new URLSearchParams({
    'form_type': 'contact',
    'utf8': '✓',
    'contact[email]': email,
    'contact[Onderwerp]': 'TENDD to Change Scan',
    'contact[body]': lines
  });

  const done = function () { renderResult(); };
  fetch('/contact', { method: 'POST', body: body }).then(done, done);
  // Never leave someone staring at a spinner because a network call hung.
  setTimeout(done, 2500);

  return false;
}

function restartScan() {
  Object.keys(answers).forEach(function (k) { delete answers[k]; });
  document.querySelectorAll('.scan-screen input[type=radio]').forEach(function (r) { r.checked = false; });
  document.querySelectorAll('.scan-field input:not(#plan-hoogste)').forEach(function (i) { i.value = ''; });
  pendingResult = null;
  resultTracked = false;
  clearProgress();
  updateProgress();
  goTo('intro');
}

document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('sections')) return;

  buildScan();
  updateProgress();
  if (loadProgress()) {
    updateProgress();
    document.getElementById('resume-banner').style.display = 'block';
  }

  document.getElementById('calc-btn').addEventListener('click', calculate);
  document.getElementById('scan-email-form').addEventListener('submit', submitEmail);
  document.querySelectorAll('[data-scan-goto]').forEach(function (el) {
    el.addEventListener('click', function () { goTo(el.getAttribute('data-scan-goto')); });
  });
  document.querySelectorAll('[data-scan-restart]').forEach(function (el) {
    el.addEventListener('click', restartScan);
  });
  document.querySelectorAll('[data-scan-print]').forEach(function (el) {
    el.addEventListener('click', function () { window.print(); });
  });
});
